import { fetchApi } from '@/config/axiosSetting';

import {
  BodySubstitutionPartsListParams,
  BodySubstitutionPartsListResponse,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySubstitutionPartsList/getBodySubstitutionPartsListQuery.type';

export const BodySubstitutionPartsListQueryFunction = (
  params: BodySubstitutionPartsListParams,
): Promise<BodySubstitutionPartsListResponse> =>
  fetchApi.get(`body/reports/${params.id}/adjusting/substitution_parts/list/`, {
    params,
  });
